import React from 'react';
export function PaymentRequestsShimmer() {
  return <div className="space-y-6 animate-pulse" role="status" aria-busy="true" aria-live="polite" data-id="element-13703">
      <span className="sr-only" data-id="element-13704">Loading payment requests…</span>
      {/* Header */}
      <div className="flex justify-between items-center" data-id="element-13705">
        <div className="h-6 w-56 bg-gray-200 rounded" data-id="element-13706" />
        <div className="h-10 w-40 bg-gray-200 rounded-md" data-id="element-13707" />
      </div>
      {/* Tabs */}
      <div className="border-b border-gray-200 pb-0" data-id="element-13708">
        <div className="flex gap-8" data-id="element-13709">
          {[1, 2, 3, 4, 5].map(i => <div key={i} className="pb-4" data-id="element-13710">
              <div className="h-4 w-24 bg-gray-200 rounded" data-id="element-13711" />
            </div>)}
        </div>
      </div>
      {/* Form Content */}
      <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-13712">
        <div className="space-y-6" data-id="element-13713">
          {/* Amount section */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-13714">
            <div data-id="element-13715">
              <div className="h-4 w-20 bg-gray-200 rounded mb-2" data-id="element-13716" />
              <div className="h-12 w-full bg-gray-200 rounded-md" data-id="element-13717" />
            </div>
            <div data-id="element-13718">
              <div className="h-4 w-24 bg-gray-200 rounded mb-2" data-id="element-13719" />
              <div className="h-12 w-full bg-gray-200 rounded-md" data-id="element-13720" />
            </div>
          </div>
          {/* Description */}
          <div data-id="element-13721">
            <div className="h-4 w-28 bg-gray-200 rounded mb-2" data-id="element-13722" />
            <div className="h-24 w-full bg-gray-200 rounded-md" data-id="element-13723" />
          </div>
          {/* Additional fields */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-13724">
            {[1, 2, 3, 4].map(i => <div key={i} data-id="element-13725">
                <div className="h-4 w-32 bg-gray-200 rounded mb-2" data-id="element-13726" />
                <div className="h-10 w-full bg-gray-200 rounded-md" data-id="element-13727" />
              </div>)}
          </div>
        </div>
      </div>
      {/* Action bar */}
      <div className="bg-white rounded-lg border border-gray-200 p-6 flex justify-between items-center" data-id="element-13728">
        <div className="h-4 w-96 bg-gray-200 rounded" data-id="element-13729" />
        <div className="h-10 w-40 bg-gray-200 rounded-md" data-id="element-13730" />
      </div>
    </div>;
}